import { useState } from "react";
import { SessionsCalendar } from "./components/SessionsCalendar";
import { Box, LinearProgress } from "@mui/material";
import { UseRecordsOptions } from "../../api/useRecords";
import { RecordsHeader } from "../../components/recordsHeader/RecordsHeader";
import { useCollection } from "../../api/useCollection";
import { ToggleBetweenCalendarAndList } from "./components/ToggleBetweenCalendarAndList";
import { Records } from "../../components/records/Records";
import { useTechnicianCurrentWeekSessionsClinics } from "../../api/useTechnicianCurrentWeekClinics";
import { useUserTodayClinic } from "../../api/useUserTodayClinic";

type View = "list" | "calendar";

type SessionsListProps = {
    entity: string;
    fieldsQuery: string;
    options?: UseRecordsOptions;
};

export function Sessions({ entity, fieldsQuery, options }: SessionsListProps) {
    const [view, setView] = useState<View>("calendar");
    const { data: collection, status: statusCollection } = useCollection(entity);

    const userTodayClinic = useUserTodayClinic({defaultClinic: 1, adminDefaultClinic: 1});
    const technicianCurrentWeekClinics = useTechnicianCurrentWeekSessionsClinics();
    const clinics = technicianCurrentWeekClinics.uniqueClinicIds.length > 1 ? technicianCurrentWeekClinics.uniqueClinicIds : userTodayClinic ? [userTodayClinic].flat() : [] as Array<number>;

    if (view === "list") {
        if (statusCollection === "loading" || technicianCurrentWeekClinics.isStatusLoading || clinics?.length === 0 || !technicianCurrentWeekClinics.isStatusSuccess) return <LinearProgress color="secondary" />;
        if (statusCollection === "error" || technicianCurrentWeekClinics.isStatusError) return <div>error</div>;
        return (
            <Records
                entity={entity}
                fieldsQuery={fieldsQuery}
                options={options}
                heightOfHeaders={228}
                header={
                    <RecordsHeader
                        collection={collection}
                        optionalComponents={{ bellowTitle: <ToggleBetweenCalendarAndList setView={setView} /> }}
                    />
                }
            />
        );
    }
    if (clinics?.length === 0 || !technicianCurrentWeekClinics.isStatusSuccess) return <LinearProgress color="secondary" />;

    return (
        <Box>
            <SessionsCalendar setView={setView} clinics={clinics} />
        </Box>
    );
}
